import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import "bootstrap-italia/dist/css/bootstrap-italia.min.css";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link } from "react-router-dom";
import Repo from "../Utility/Repo";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router";

function TabellaFascicolo(props) {
  const [cookies] = useCookies();
  const [apiToken] = useState(cookies.api_token);

  const getPdf = async (obbj) => {
    Repo.getCartellaDownload(
      obbj.tokenDownload,
      obbj.idCartella,
      obbj.idTipoEntrata
    )
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      {props.children && props.children.length !== 0 ? (

        <>
          <div className="card-wrapper">
            <div className="card-body">
              {/* -------------------------------------------- */}
              {!props.table ? (
                <>
                  {Array.isArray(props.children) &&
                    props.children.map((obbj, index) => (
                      <div
                        id="collapseDiv1-sc1"
                        className="collapse-div collapse-background"
                        role="tablist"
                        key={index}
                      >
                        <div
                          className="collapse-header"
                          id={"heading1-sc" + index}
                        >
                          <button
                            data-toggle="collapse"
                            data-target={"#collapse1-sc" + index}
                            aria-expanded="true"
                            aria-controls={"collapse1-sc" + index}
                          >
                            {obbj.nomeUnivocoCartella}
                            <div className="row">
                              <div className="col-6">
                                <b>Data Emissione: </b>{" "}
                                {moment(
                                  new Date(obbj.dataEmissioneCartella)
                                ).format("DD-MM-YYYY")}
                              </div>

                              {obbj.dataNotificaCartella && <div className="col-6">
                                <b>Data Notifica: </b>{" "}
                                {moment(
                                  new Date(obbj.dataNotificaCartella)
                                ).format("DD-MM-YYYY")}
                              </div>}

                            </div>
                          </button>
                        </div>
                        <div
                          id={"collapse1-sc" + index}
                          className="collapse"
                          role="tabpanel"
                          aria-labelledby={"heading1-sc" + index}
                        >
                          <div className="collapse-body">
                            <div className="row">
                              <div className="col-8">

                                <div className="row">

                                  {/* <a href={window.location.href.split("?id=")[0]+"?id=" + obbj.idCartella}>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm  btn-icon"
                                      style={{ marginRight: "5px" }}

                                    >
                                   
                                      <svg className="icon icon-sm icon-white">
                                        <use href={`${iconSprite}#it-file`} />
                                      </svg>{" "}
                                      <span>Dettaglio</span>
                                    </button>

                                  </a>
 */}

                                  <button
                                    type="button"
                                    className="btn btn-secondary btn-sm "
                                    onClick={() => getPdf(obbj)}
                                  >
                                    <svg className="icon icon-sm icon-white">
                                      <use href={`${iconSprite}#it-download`} />
                                    </svg>{" "}
                                    <span>Scarica</span>
                                  </button>
                                </div>
                              </div>
                              <div className="col-4">
                                <div className="row">
                                  <b>Anno Imposta: </b> {obbj.annoImposta}
                                </div>
                                <div className="row">
                                  <b> Dovuto: </b> {obbj.importoDovuto} €
                                </div>
                                <div className="row">
                                  <b>Già Versato: </b> {obbj.importoGiaVersato ? obbj.importoGiaVersato : 0}{" "}
                                  €
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}{" "}
                </>
              ) : (
                <>
                  <div className="row">
                    <div className="col-12">
                      <div
                        className="card card-teaser rounded text-primary font-weight-bold"
                        style={{ fontSize: "32px" }}
                      >
                        Lista Cartelle
                      </div>

                      {Array.isArray(props.children) &&
                        props.children.map((obbj, index) => (
                          <div
                            className="card card-teaser rounded shadow mb-2"
                            key={index}
                          >
                            <div className="card-body">
                              <div className="text-left">
                                <div className="row">
                                  <div className="col-lg-8 col-sm-12">
                                    {" "}
                                    <h5 className="text-primary">
                                      {!obbj.connessioneFallita
                                        ? obbj.nomeUnivocoCartella
                                        : "Cartella Non Trovata"}
                                    </h5>
                                  </div>

                                  {!obbj.connessioneFallita && (
                                    <div className="col-lg-4 col-sm-12 d-flex flex-row-reverse">
                                      {" "}
                                      <button
                                        type="button"
                                        className="btn btn-secondary btn-sm mb-2 btn-icon"
                                        onClick={() => getPdf(obbj)}
                                      >
                                        <svg className="icon icon-sm icon-white">
                                          <use
                                            href={`${iconSprite}#it-download`}
                                          />
                                        </svg>{" "}
                                        <span>Scarica</span>
                                      </button>
                                      <Link to={"/fascicolo/dettaglio_fascicolo?id=" + obbj.idCartella}>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-sm mb-2 btn-icon"
                                          style={{ marginRight: "5px" }}

                                        >

                                          <svg className="icon icon-sm icon-white">
                                            <use href={`${iconSprite}#it-file`} />
                                          </svg>{" "}
                                          <span>Dettaglio</span>
                                        </button>

                                      </Link>

                                    </div>
                                  )}
                                </div>

                                {/*console.log("(obbj.importoGiaVersato==obbj.importoIniziale):" + (obbj.importoGiaVersato==obbj.importoIniziale))*/}
                                
                                {!obbj.connessioneFallita && (
                                  <>
                                    {" "}
                                    <div className="row mt-3">
                                      {/*obbj.dataNotificaCartella && <div className="col-sm-6 col-lg-3">
                                        Data Notifica:{" "}
                                        <b>
                                          {" "}
                                          {moment(
                                            new Date(obbj.dataNotificaCartella)
                                          ).format("DD-MM-YYYY")}{" "}
                                        </b>
                                          </div>*/}
                                      
                                      {(obbj.dataNotificaCartella!=null)
                                      ?
                                      <div className="col-sm-6 col-lg-3">
                                        <span>Data Notifica:</span>
                                        <b>
                                          {" "}
                                          {moment(
                                            new Date(obbj.dataNotificaCartella)
                                          ).format("DD-MM-YYYY")}{" "}
                                        </b>
                                      </div>
                                      :   
                                      <div className="col-sm-6 col-lg-3">
                                        <span>{" "}</span>                                        
                                      </div>
                                      }

                                      <div className="col-sm-6 col-lg-3 ">
                                        Dovuto Iniziale: <b>{obbj.importoIniziale} € </b>
                                      </div>
                                      <div className="col-sm-6 col-lg-3">
                                        Già Versato:<b> {obbj.importoGiaVersato ? obbj.importoGiaVersato : 0}{" "}
                                          €</b>
                                      </div>
                                      {obbj.flagPagabile == 1 ? (


                                        <div className="col-sm-6 col-lg-3">
                                          <svg className="icon icon-sm mb-1">
                                            <use
                                              href={`${iconSprite}#it-warning-circle`}
                                            />
                                          </svg>{" "}

                                          <span>Da Pagare</span>

                                          <b> {obbj.importoDovuto ? obbj.importoDovuto : 0}{" "}
                                            €</b>

                                          {" "}
                                        </div>
                                      ) :
                                     
                                      (obbj.importoGiaVersato==obbj.importoIniziale) 
                                      ? <div className="col-sm-6 col-lg-3">
                                      <svg className="icon icon-sm mb-1 icon-success">
                                            <use
                                              href={`${iconSprite}#it-check-circle`}
                                            />
                                          </svg>{" "}
                                          <span className="text-warning">Pagata</span>                
                                    </div>                    
                                      : <div className="col-sm-6 col-lg-3">             
                                          <svg className="icon icon-sm mb-1 icon-warning">
                                            <use
                                              href={`${iconSprite}#it-warning-circle`}
                                            />
                                          </svg>{" "}
                      
                                          <span className="text-warning">Non Pagabile:</span>
                      
                                          <b > {obbj.motivoNonPagabile && obbj.motivoNonPagabile}</b>
                      
                                          {" "}
                      
                                      </div>

                                        /*<div className="col-sm-6 col-lg-3">
                                          <svg className="icon icon-sm mb-1 icon-danger">
                                            <use
                                              href={`${iconSprite}#it-warning-circle`}
                                            />
                                          </svg>{" "}

                                          <span className="text-danger">Non Pagabile</span>

                                          <b > {obbj.motivoNonPagabile  && obbj.motivoNonPagabile  }</b>

                                          {" "}
                                        </div>*/
                                        
                                        
                                        }
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <b>Nessun Risultato da Mostrare</b>
      )
      }
    </>
  );
}

export default TabellaFascicolo;
